import { NormalizedCacheObject } from '@apollo/client';
import { ApolloClient } from '@apollo/client/core/ApolloClient';
import { ApolloProvider } from '@apollo/client/react/context/ApolloProvider';
import { PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  client: ApolloClient<NormalizedCacheObject>;
}

export const ApolloWrapper = ({ children, client }: Props) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
